// src/pages/Home.tsx
import React from "react";
import { getIdToken, logout } from "../auth";
import { decodeJwt } from "../jwt";

export default function InactiveNotice() {
    const idToken = getIdToken();
    const claims = idToken ? decodeJwt(idToken) : null;
    const email =
        claims?.email ??
        claims?.["cognito:username"] ??
        null;

    const handleLogout = () => {
        // Clears tokens + redirects to Cognito logout_uri
        logout();
    };

    return (
        <div
            style={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#0b1120",
                fontFamily:
                    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
            }}
        >
            <div
                style={{
                    background: "#ffffff",
                    padding: "2.5rem 2.75rem",
                    borderRadius: "1rem",
                    boxShadow: "0 18px 45px rgba(15, 23, 42, 0.3)",
                    maxWidth: "480px",
                    width: "100%",
                    boxSizing: "border-box",
                }}
            >
                <h1
                    style={{
                        margin: 0,
                        marginBottom: "0.35rem",
                        fontSize: "1.5rem",
                        fontWeight: 600,
                        color: "#0f172a",
                    }}
                >
                    Account inactive
                </h1>

                <p
                    style={{
                        marginTop: 0,
                        marginBottom: "1rem",
                        fontSize: "0.95rem",
                        color: "#64748b",
                    }}
                >
                    {email ? (
                        <>
                            The account <strong>{email}</strong> exists in the system,
                            but it has not been activated yet. A system administrator
                            has been notified and should respond shortly.
                        </>
                    ) : (
                        <>
                            Your account exists in the system, but it has not been
                            activated yet. A system administrator has been notified and
                            should respond shortly.
                        </>
                    )}
                </p>

                <p
                    style={{
                        marginTop: 0,
                        marginBottom: "1.5rem",
                        fontSize: "0.9rem",
                        color: "#64748b",
                    }}
                >
                    If this isn’t the right account, you can log out and sign in again
                    with a different user.
                </p>

                <button
                    type="button"
                    onClick={handleLogout}
                    style={{
                        borderRadius: "999px",
                        border: "none",
                        padding: "0.6rem 1.25rem",
                        background: "#0f172a",
                        color: "#ffffff",
                        fontSize: "0.95rem",
                        fontWeight: 500,
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "0.4rem",
                    }}
                >
                    Log out
                </button>
            </div>
        </div>
    );
}
